// 引入api
import { fun_GetAction, fun_PostAction } from "@/api";
// 引入加密方法
import "@/utils/security.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 抽屉状态
      drawerStatus: false,
      // 抽屉确定按钮loading状态
      loading: false,
      // 查询表单字段
      form: {
        id: null, // id
        ip: null, // ip
        ipType: null, // ip类型
        virtualNetworking: null, // 物理网卡
        hardDiskId: null, // 硬盘序列号
        regulators: null, // 监管
        insertDate: null, // 插入日期
        updateDate: null // 更新日期
      },
      // 表单提交返回的错误消息
      errRules: {
        ip: null, // ip
        ipType: null, // ip类型
        virtualNetworking: null, // 物理网卡
        hardDiskId: null, // 硬盘序列号
        regulators: null //监管
      },
      // 详情表单基础数据
      formConfigList: [
        {
          label: "ip：",
          value: "ip",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "ip类型：",
          value: "ipType",
          type: "select",
          required: false,
          clearable: true,
          disabled: false,
          queryParams: {
            sqlId: "13f3e366-dbb0-4ea2-a6bf-6b84339ab42c",
            dictionaryId: "1536880170983444480"
          }
        },
        {
          label: "物理网卡：",
          value: "virtualNetworking",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "硬盘序列号：",
          value: "hardDiskId",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "区管部门：",
          value: "regulators",
          type: "select",
          required: true,
          clearable: true,
          disabled: false,
          rule: {
            required: true,
            message: "请选择区管部门",
            trigger: "change"
          },
          queryParams: {
            sqlId: "13f3e366-dbb0-4ea2-a6bf-6b84339ab42c",
            dictionaryId: "1536881476624142336"
          }
        }
      ],
      // 操作类型
      type: null
    };
  },

  // 模板编译完成
  mounted() {},

  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author shuhua
     */
    async fun_GetDetails(id) {
      this.form.id = id;
      // 请求，获取结果集
      let res = await fun_GetAction("/ipInfo/detail?id=" + id);
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 回显表单
        this.form = data;
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 表单提交
     * @author shuhua
     */
    fun_SubmitForm() {
      // 校验
      this.$refs.form.$refs.enInform.validate(valid => {
        // 校验通过
        if (valid) {
          // 打开确定按钮loading状态
          this.loading = true;
          // 发起请求，获取结果集
          fun_PostAction("/ipInfo/saveOrUpdate", this.form)
            .then(res => {
              // 解构res.data
              const { result, msg, data } = res.data;
              // 判断请求是否成功
              if (result) {
                // 关闭抽屉
                this.drawerStatus = false;
                // 请求一览查询接口
                this.$parent.fun_GetList();
                // 提示信息
                this.$message.success(msg);
              } else {
                // 如果存在返回数据
                if (data != null) {
                  // 定义rules为一个随机数
                  this.errRules = Math.random();
                  // 执行延迟方法
                  this.$nextTick(() => {
                    // 提示
                    this.$message.error("请按提示修改");
                    // 赋值错误消息
                    this.errRules = data;
                  });
                } else {
                  // 请求失败，提示信息
                  this.$message.error(msg);
                }
              }
              // 取消确定按钮loading状态
              this.loading = false;
            })
            .catch(() => {
              // 取消确定按钮loading状态
              this.loading = false;
            });
        } else {
          // 校验不通过，返回false，页面给出提示
          return false;
        }
      });
    },
    /**
     * 选择下拉框事件
     * @param {e} 选择的value值
     * @param {val} 下拉框的字段
     * @author shuhua
     */
    fun_GetSelectVal(e, val) {
      // 遍历查询表单对象
      for (const key in this.form) {
        // 判断key和val是否相同
        if (key == val) {
          // 相同则复制给表单
          this.form[key] = e;
        }
      }
    },
    /**
     * 抽屉关闭时执行
     * @author 滕威
     */
    fun_DrawerClose() {
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
      // 关闭时，清除勾选
      this.$parent.$refs.list.$refs.multipleTable.clearSelection();
    }
  }
};
